import React, { Component, useDebugValue } from 'react';
import { Link } from 'react-router';
import { Row, Col } from 'reactstrap';
// import { FieldCol, FieldGroup, FieldLabel, FieldInput, FieldSelect, FieldTextarea, FieldDate} from '../../Elements';
import { leaseTypeDrpdwn } from '../../../../constants';
import {checkString} from '../../../../formValidator'
import { jetStreamInstance } from '../../../Leases';
import { FieldCol, FieldGroup, FieldInput, FieldLabel, FieldSelect, FieldTextarea } from '../../../../applications/contracts/Elements';
export default class EditEngineRight extends Component{
  constructor(props){
    super(props);
    this.state = {
      engineRight_details: {},
      error: {}
    }
  }
  componentDidMount(){
    this.updateHdState(this.props.engineRight);
  }
  updateHdState = (engineRight) => {
    let data = Object.assign({}, engineRight);
    this.setState({
        engineRight_details: data
    });
  }
  updateForm = (type, value) => {
      this.setState(prevState => ({
        engineRight_details: {
          ...prevState.engineRight_details,
          titan_extra_fields: {
            ...prevState.engineRight_details?.titan_extra_fields,
            [type]: value,
          },
        },
      }));
  }

  updateContributions =  (e) => {
    e.preventDefault();
    let data = Object.assign({}, this.state.engineRight_details);
    this.props.updateContributions({data});

  }
  render(){
    const { type} = this.props;
    const { engineRight_details } = this.state;
      return(
        <form onSubmit={(e) => this.updateContributions(e)}>
          <div style={{ height: (window.innerHeight - 157) + 'px', overflow:'auto',marginBottom:'60px' }}>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Engine Title Swap Rights</FieldLabel>
                    <FieldSelect
                      placeholder='Select YES/NO'
                      keyParam="engine_title_swap_rights"
                      value={engineRight_details?.titan_extra_fields?.engine_title_swap_rights || ''}
                      type={type}
                      options={[{ label: 'YES', value: 'YES' },{ label: 'NO', value: 'NO' }]}
                      updateField={this.updateForm}
                      labelKey='label'
                      valueKey='value'
                    />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Engine Pooling Rights</FieldLabel>
                    <FieldSelect
                      placeholder='Select YES/NO'
                      keyParam="engine_pooling_rights"
                      value={engineRight_details?.titan_extra_fields?.engine_pooling_rights || ''}
                      type={type}
                      options={[{ label: 'YES', value: 'YES' },{ label: 'NO', value: 'NO' }]}
                      updateField={this.updateForm}
                      labelKey='label'
                      valueKey='value'
                    />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Engine Swap Lessor Consent Required</FieldLabel>
                    <FieldSelect
                      placeholder='Select YES/NO'
                      keyParam="engine_swap_lessor_consent"
                      value={engineRight_details?.titan_extra_fields?.engine_swap_lessor_consent || ''}
                      type={type}
                      options={[{ label: 'YES', value: 'YES' },{ label: 'NO', value: 'NO' }]}
                      updateField={this.updateForm}
                      labelKey='label'
                      valueKey='value'
                    />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Remarks</FieldLabel>
                  <FieldTextarea
                    value={engineRight_details?.titan_extra_fields?.engine_right_remark}
                    type={type}
                    keyParam="engine_right_remark"
                    updateField={this.updateForm}
                    rows={3}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
         </div>
         <div className="submit-block">
           <input type="submit" className="primary-btn" value="Save Changes"/>
           <Link onClick={() => this.props.toggleEditSideBar()} >Cancel</Link>
         </div>
       </form>
      )
  }
}
